import { Flex, Skeleton } from 'antd'

const NUM_OF_ITEMS = 5

function MenuSkeleton() {
  return (
    <Flex
      vertical
      gap="middle"
      className="w-full px-3"
      data-testid="sidebar-menu-skeleton"
    >
      {Array.from({ length: NUM_OF_ITEMS }, () => (
        <Skeleton.Input
          active
          size="small"
          className="!w-full"
          key={crypto.randomUUID()}
        />
      ))}
    </Flex>
  )
}

export default MenuSkeleton
